/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { mediaImageDestroy } from '../../axios/mediaImageDestroy'
import type {
	MediaImageDestroyError,
	MediaImageDestroyPathParams,
	MediaImageDestroyResponse,
} from '../../types/MediaImageDestroy'

export const mediaImageDestroyMutationKey = () => [{ url: '/media/:organisation/:media' }] as const

export type MediaImageDestroyMutationKey = ReturnType<typeof mediaImageDestroyMutationKey>

export type MediaImageDestroyVariables = {
	organisation: MediaImageDestroyPathParams['organisation']
	media: MediaImageDestroyPathParams['media']
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/MediaImageController.php MediaImageController::destroy */
export function useMediaImageDestroy<TContext = unknown>(
	options?: UseMutationOptions<
		MediaImageDestroyResponse,
		AxiosError<MediaImageDestroyError>,
		MediaImageDestroyVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: mediaImageDestroyMutationKey(),
		mutationFn: ({ organisation, media }: MediaImageDestroyVariables) =>
			mediaImageDestroy(organisation, media, config).then(res => res.data),
		...options,
	})
}
